import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserDetailsFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { DatePipe } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-edit-organization-year-end',
  templateUrl: './edit-organization-year-end.component.html',
  styleUrls: ['./edit-organization-year-end.component.css'],
})
export class EditOrganizationYearEndComponent {
  @Output() saveorgYearEndEvent = new EventEmitter<any>();
  modalLabel: any;
  orgYearEndData: any;
  organizationName: any;
  orgYearEndEditForm!: FormGroup;
  currentUserRole: any;
  submitted = false;
  date = '';
  orgYearEndMonth: any;
  organizationYearEndDate: any;

  constructor(
    private formBuilder: FormBuilder,
    private modal: CustomModalService,
    private userDetails: UserDetailsFacade,
    private datePipe: DatePipe,
    private cookieService: CookieService
  ) {
    this.userDetails.profileData$.subscribe(data => {
      this.organizationName = data.organizationName;
      this.currentUserRole = data.roleName;
    });
    this.modalLabel = this.modal?.modalService?.config?.initialState?.['headerName'];
    this.orgYearEndData = this.modal?.modalService?.config?.initialState?.['orgYearEndData'];
    this.date = this.orgYearEndData.organizationYearEndDate;
  }

  ngOnInit(): void {
    this.orgYearEndEditForm = this.formBuilder.group({
      orgYearEnd: [this.orgYearEndData.organizationYearEndDate || '', Validators.required],
    });
  }

  onClose() {
    this.modal.close();
  }

  onOpenCalendar(container: any) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('month');
  }

  onValueChange(event: any) {
    this.organizationYearEndDate = this.datePipe.transform(event, 'MMMM');
  }

  onSave() {
    this.submitted = true;
    if (!!this.organizationYearEndDate) {
      const supplierAddEditPayload = {
        organizationId: Number(this.cookieService.get('organizationId')),
        organizationName: this.organizationName,
        organizationYearEndDate: this.organizationYearEndDate,
        currentUserRole: this.currentUserRole,
      };
      this.saveorgYearEndEvent.emit(supplierAddEditPayload);
    }
  }
}
